import { Navigate } from "react-router-dom";
import { useLoginUser } from "../context/loginUser";

const isLoggedIn = (user, token) =>
  typeof token === "string" &&
  token?.length > 0 &&
  user !== "" &&
  user != null;

// GuestGuard component to protect routes meant for unauthenticated users
export const GuestGuard = ({ children }) => {
  const { user, token } = useLoginUser();

  if (isLoggedIn(user, token)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
